import { mergeDeepWithKey } from 'ramda';

export const mergeDeepRightWithArray = (lObj: unknown, rObj: unknown): unknown => {
  const fn = (k: string, x: unknown, z: unknown): unknown => {
    if (Array.isArray(x) && Array.isArray(z)) {
      const resultArray: unknown[] = [];
      const maxLength = Math.max(x.length, z.length);

      for (let i = 0; i < maxLength; i += 1) {
        resultArray.push(mergeDeepRightWithArray(x[i], z[i]));
      }

      return resultArray;
    }

    return z || x;
  };

  return mergeDeepWithKey(fn, lObj, rObj);
};
